module.exports = __webpack_public_path__ + "static/umowa_o_prowadzenie_windykacji-ec1a8476192d06488f50944cc0d7626b.pdf";